<template>
  <div>
    <SOSlotModal
      modal-title="Simpan Reschedule"
      :modal-id="'popUpJadwalConfirm'"
      :no-padding="false"
      @close="close"
    >
      <template v-slot:modal-body>
        <p class="f-Overpass f-14 f-c-midgrey p-t-16">
          Apakah kamu yakin ingin menyimpan jadwal reschedule?
        </p>

        <div class="d-flex-between-center">
          <p class="f-14 f-Overpass f-c-midgrey">
            {{ dataRescedule.jadwal_ke }}
          </p>
          <p class="f-14 f-Overpass f-c-black">
            {{
              $moment(dataRescedule.jadwal_mulai).format("DD MMMM YYYY HH:mm")
            }}
          </p>
        </div>
      </template>

      <template v-slot:modal-footer>
        <button
          class="btn btn-primary btn-long bg-blue"
          :disabled="checkValidationAPI"
          @click="postResceduleClick"
        >
          Lanjutkan
        </button>
      </template>
    </SOSlotModal>
  </div>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";

export default {
  name: "ModalConfirmRescedule",
  components: {
    SOSlotModal,
  },
  props: {
    idjenis: "",
  },
  data() {
    return {
      checkValidationAPI: false,
    };
  },
  computed: {
    ...mapGetters(moduleName, {
      dataRescedule: "dataRescedule",
    }),
  },
  methods: {
    ...mapActions({
      postRescedule: `${moduleName}/postRescedule`,
    }),
    async postResceduleClick() {
      this.checkValidationAPI = true;
      let data = {
        idJenis: this.idjenis,
        idDetailTraining: this.dataRescedule.id_detail_training,
        jadwalMulai: this.dataRescedule.jadwal_mulai,
        jadwalSelesai: this.dataRescedule.jadwal_selesai,
      };

      const res = await this.postRescedule(data)
        .then((res) => {
          this.checkValidationAPI = true;
          if (!res.data) {
            if (
              res ==
              "Kesalahan sistem, harap hubungi pusat bantuan (record not found)"
            ) {
              this.$toast.error("Mohon Coba Kembali");
              this.$toast.error(res);
              this.$router.go(-2);
              this.checkValidationAPI = false;
            }
            if (res == "jadwal penuh") {
              this.$toast.error(res);
              this.checkValidationAPI = false;
            }
          } else {
            if (res.data.code == 200) {
              this.checkValidationAPI = true;
              this.dataRescedule.jadwal_mulai = "";
              this.dataRescedule.jadwal_selesai = "";
              this.$toast.success("Jadwal berhasil diubah");
              this.$router.go(-1);
            }
          }
        })
        .catch((error) => {
          this.$toast.error(error);
          this.$router.go(-1);
          this.checkValidationAPI = true;
        });
    },
    open() {
      $(`#popUpJadwalConfirm`).modal("show");
    },
    close() {
      $(`#popUpJadwalConfirm`).modal("hide");
    },
  },
};
</script>
